// ⓘ next to a date label: the shell's TextTooltip (hover, keyboard focus, Esc, aria-label) with ONE shared text per date concept (dispatch namespace: datesHelp.*).
// k = dispatchDate | dispatchEta | deliveryDate | orderLineEta | orderDate. (datesHelp.expectedPickup is reserved for pickup slips once delivery_method exists.)
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextTooltip } from '../../../components/HelpIcon';

export default function DateHelp({ k }) {
  const { t } = useTranslation('dispatch');
  const text = t(`datesHelp.${k}`);
  return <TextTooltip text={text} ariaLabel={`${t(`dates.${k}`)}: ${text}`} />;
}
